import { render, staticRenderFns } from "./courseDetails.vue?vue&type=template&id=e57c07c6&scoped=true&"
import script from "./courseDetails.vue?vue&type=script&lang=js&"
export * from "./courseDetails.vue?vue&type=script&lang=js&"
import style0 from "./courseDetails.vue?vue&type=style&index=0&id=e57c07c6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e57c07c6",
  null
  
)

export default component.exports